import Grid from '@mui/material/Grid';
import { FC, memo } from 'react';
import { FieldValues, useFormContext, UseFormRegister } from 'react-hook-form';

import useRole from '~/store/user/hooks/useRole';
import DatePicker from '~/ui/components/inputs/DatePicker';
import Input from '~/ui/components/inputs/Input';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';
import TimePicker from '~/ui/components/inputs/TimePicker';

import { TypeOfVisit } from '~/ui/pages/Visits/constants/filterOptions';
import formatEnumToOptions from '~/ui/pages/Visits/utils/formatEnumToOptions';

import styles from './VisitDateSelectFields.module.scss';

interface IProps {
  clientNoShow: boolean;
}

const VisitDateSelectFields: FC<IProps> = ({ clientNoShow }) => {
  const { isGlobalUser } = useRole();

  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  const registerMinutes: UseFormRegister<FieldValues> = (name, options) =>
    register(name, { ...options, deps: 'durationHours' });

  return (
    <>
      <Grid
        size={{
          sm: isGlobalUser ? 2 : 3,
        }}
      >
        <DatePicker
          control={control}
          errors={errors}
          name="date"
          openTo="date"
          label="Date of Visit"
          maxDate={new Date().toISOString()}
        />
      </Grid>
      <Grid
        size={{
          sm: 3,
        }}
      >
        <Select
          control={control}
          errors={errors}
          name="type"
          options={formatEnumToOptions(TypeOfVisit)}
          label="Type of Visit"
          hideSelectedOptions={false}
          openMenuOnFocus
        />
      </Grid>
      <Grid
        size={{
          sm: isGlobalUser ? 2 : 3,
        }}
      >
        <TimePicker
          control={control}
          errors={errors}
          name="startTime"
          label={clientNoShow ? 'Time of Visit' : 'Start time'}
        />
      </Grid>
      {!clientNoShow && (
        <Grid
          size={{
            sm: isGlobalUser ? 2 : 3,
          }}
        >
          <div className={styles.duration}>
            <Input
              name="durationHours"
              label="Hours"
              ariaLabel="Hours"
              inputMode="numeric"
              tabIndex={0}
              register={register}
              errors={errors}
            />
            <Input
              name="durationMinutes"
              label="Minutes"
              ariaLabel="Minutes"
              inputMode="numeric"
              tabIndex={0}
              register={registerMinutes}
              errors={errors}
            />
          </div>
        </Grid>
      )}
    </>
  );
};

export default memo(VisitDateSelectFields);
